import { injectGlobal } from 'styled-components';
import styles from './styles';
import './index.css';

injectGlobal`
  @font-face {
    font-family: ApercuBlack;
    src: url(${process.env.PUBLIC_URL}/fonts/apercu-black.otf);
  }
  @font-face {
    font-family: ApercuBold;
    src: url(${process.env.PUBLIC_URL}/fonts/apercu-bold.otf);
  }
  @font-face {
    font-family: ApercuLight;
    src: url(${process.env.PUBLIC_URL}/fonts/apercu-light.otf);
  }
  @font-face {
    font-family: ApercuMedium;
    src: url(${process.env.PUBLIC_URL}/fonts/apercu-medium.otf);
  }
  @font-face {
    font-family: ApercuMono;
    src: url(${process.env.PUBLIC_URL}/fonts/apercu-mono.otf);
  }
  @font-face {
    font-family: ApercuMono;
    src: url(${process.env.PUBLIC_URL}/fonts/apercu-mono-bold.otf);
    font-weight: bold;
  }

  html {
    font-size: 0.8333333333333vw;
    width: 100%;
    overflow-x: hidden;
    
    
    ${styles.media.tablet`
    font-size: 1.0416666666667vw;
    `}
    ${styles.media.phone`
      font-size: 3.2vw;
    `};
  }
  
  @media screen and (min-width: 1920px) {
    html {
      font-size: 16px;
    }
  }

  body {
    overflow-x: hidden;
    background: white;
    
    user-select: text;

    -webkit-tap-highlight-color: rgba(0,0,0,0);
    background-position: 0 0;
    background-repeat: no-repeat;
    background-size: 100%;
    font-family: 'ApercuLight', 'Helvetica', 'Arial', sans-serif;
    color: ${styles.color.CHARCOAL};
    -webkit-font-smoothing: antialiased;

    &.no-overflow {
      overflow: hidden;
    }
  }

  #root {
    position: relative;
  }

  h1 { font-family: ApercuBlack; font-weight: bold; font-size: 6.5rem; ${styles
    .media.phone` font-size: 2.833333333333333rem;`} }
  h2 { font-family: ApercuBlack; font-weight: bold; font-size: 3.5rem; ${styles
    .media.phone` font-size: 2.833333333333333rem;`} }
  h3 {}
  h4 { font-family: ApercuBold; font-weight: bold; font-size: 2rem; margin-bottom: 1em; }
  h5 {}
  h6 {}

  p.lead {
    font-size: 2rem;
    line-height: 2rem;
    color: ${styles.color.SLATE_LIGHT};
  }
  
  p {
    font-size: 1.25rem;
    ${styles.media.tablet`
      font-size: 1.75rem;
    `}
    ${styles.media.phone`
      font-size: 1.25rem;
    `}
    line-height: 1.6em;
    margin-bottom: 1.6em;
  }
  
  .speaker-bio {
  	width:100%;
	overflow:hidden;
	margin-bottom: 1.65em;
  }
  
  .speaker {
  	width:20%;
	max-width: 175px;
	margin-right: 20px;
	float:left;

    ${styles.media.tablet`
  	  width:60%;
      float:none;
  	  margin: 0px auto 20px auto;
    `}
    ${styles.media.phone`
	  width:60%;
      float:none;
	  margin: 0px auto 20px auto;
    `}
  }

  .bio {
    font-size: 1.25rem;
	overflow:hidden;
    ${styles.media.tablet`
      font-size: 1.75rem;
    `}
    ${styles.media.phone`
      font-size: 1.25rem;
    `}
    line-height: 1.6em;
    margin-bottom: 1.6em;
  }

  #content-wrap {
    .medium {
      font-family: ApercuMedium !important;
    }
    
    &.arial #page-content * {
      font-family: Arial;
    }

    p > a, ol a, ul a, form a {
        color: ${styles.color.ORANGE};

        position: relative;
        display: inline;
        width: calc(100%);
        background-image: linear-gradient(transparent calc(100% - 2px), #FF7500 2px);
        background-repeat: no-repeat;
        background-size: 0% 100%;
        transition: background-size .25s ${styles.easing.inOutCubic};

        .current-input-mouse &:hover,
        .current-input-touch &:active {
          background-size: 100% 100%;
        }
      }
  }
  strong { font-family: ApercuBlack; }

  #content-wrap {

    hr {
      border: 0 !important;
      margin: 5rem 0;
    }

    ol {
      counter-reset: item;

      &.content li {
        margin-top: 1.6em;
      }

      > li {
        display: block;
        &:before {
          content: counters(item, ".") ". ";
          counter-increment: item;
          display: inline-block;
        }
      }
    }

    ol > li {
      padding-left: 1.5em;
      &:before {
        width: 1.5em;
        margin-left: -1.5em;
      }
      > ol > li {
        padding-left: 2.25em;
        &:before {
          width: 2.25em;
          margin-left: -2.25em;
        }
        > ol > li {
          padding-left: 3em;
          &:before {
            width: 3em;
            margin-left: -3em;
          }
          > ol > li {
            padding-left: 3.75em;
            &:before {
              width: 3.75em;
              margin-left: -3.75em;
            }
            > ol > li {
              padding-left: 4.5em;
              &:before {
                width: 4.5em;
                margin-left: -4.5em;
              }
            }
          }
        }
      }
    }

    ol, ul {
      font-size: 1.25rem;
      ${styles.media.tablet`
        font-size: 1.75rem;
      `}
      ${styles.media.phone`
        font-size: 1.25rem;
      `}
      line-height: 1.6em;
    }
    ul {
      margin-bottom: 1.6em;
      li {
        margin-bottom: 0.8em;
        position: relative;
      padding-left: 1rem;
      &:before {
          content: '•';
          font-size: 2em;
          line-height: inherit;
          vertical-align: middle;
          position: absolute;
          left: 0;
          color: #ff7500;
        }
      }

      &.no-margin {
        margin-bottom: 0;
        > li {
          margin-bottom: 0;
          margin-top: 0;
          padding-left: 1.5em;
          &:before {
            content: unset;
          }
        }
      }
      &.no-margin-bullets {
        //margin-bottom: 0;
        > li {
          margin-bottom: 0;
          margin-top: 0;
          padding-left: 1.5em;
        }
      }
    }
  }


`;



// WEBPACK FOOTER //
// ./src/injectGlobal.js